import React, { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase/config";

const MarqueeBanner = () => {
  const [announcement, setAnnouncement] = useState("");

  useEffect(() => {
    const fetchAnnouncement = async () => {
      try {
        const docRef = doc(db, "settings", "announcement");
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setAnnouncement(docSnap.data().message);
        }
      } catch (err) {
        // Fail silently
      }
    };
    fetchAnnouncement();
  }, []);

  if (!announcement) return null;

  // Try to extract coupon code for highlighting (simple regex for all-caps alphanum)
  const codeMatch = announcement.match(/([A-Z0-9]{5,})/);
  let display;
  if (codeMatch) {
    const [code] = codeMatch;
    const parts = announcement.split(code);
    display = <>
      🎁 <span className="mx-2">{parts[0]}</span>
      <span className="bg-white text-orange-500 px-2 py-1 rounded-md font-bold shadow inline-block align-middle">{code}</span>
      <span className="mx-2">{parts[1]}</span> 🎉
    </>;
  } else {
    display = <>{announcement}</>;
  }

  return (
    <div className="w-full bg-gradient-to-r from-yellow-400 to-orange-300 shadow-inner py-3 overflow-hidden">
      <div className="animate-marquee whitespace-nowrap text-center text-base font-semibold text-black tracking-wide">
        {display}
      </div>
    </div>
  );
};

export default MarqueeBanner; 